import { resetEntityImpressionId } from '~/app/store/analytics/entityImpressionId'
import { galleryImpressionsTrackingSelectorFactory } from '~/app/store/analytics/reducer'
import { ThunkDispatch } from '~/app/store/interface'
import { AnalyticsNames } from 'shared/constants'

export const trackDirectQVDismissImpression =
  (designId: string, analytics: Gallery.Analytics.IAnalytics) => (_dispatch: ThunkDispatch, getState: () => State.GlobalState) => {
    resetEntityImpressionId(designId)
    const selectImpressions = galleryImpressionsTrackingSelectorFactory()
    const impression = selectImpressions(getState(), analytics, AnalyticsNames.DesignTile)
    analytics.trackImpression(impression)
  }
